/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getMachineryApplicationsList = (payload, callback) =>
  req.list(
    c.GET_MACHINERY_APPLICATIONS,
    '/api/v1/rpt/administrator/machineries/machinery_applications',
    payload,
    callback
  );

export const getSingleMachineryApplication = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}`,
    callback,
    payload
  );

export const createMachineryApplication = (payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_APPLICATION,
    '/api/v1/rpt/administrator/machineries/machinery_applications/',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMachineryApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/applications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getMachineryAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_APPRAISAL,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_appraisals`,
    payload,
    callback
  );

export const getSingleMachineryAppraisal = (
  id,
  machineryAppraisalId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_MACHINERY_APPRAISAL,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_appraisals/${machineryAppraisalId}`,
    callback,
    payload
  );

export const createMachineryAppraisal = (id, payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_APPRAISAL,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMachineryAppraisal = (
  id,
  machineryAppraisalId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_MACHINERY_APPRAISAL,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_appraisals/${machineryAppraisalId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeMachineryAppraisal = (
  id,
  machineryAppraisalId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_MACHINERY_APPRAISAL,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_appraisals/${machineryAppraisalId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getMachineryPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments`,
    payload,
    callback
  );

export const getSingleMachineryPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments/${landPropertyAssessmentId}`,
    callback,
    payload
  );

export const createMachineryPropertyAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMachineryPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeMachineryPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_MACHINERY_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getMachineryRecordofSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_rec_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleMachineryRecordofSupAssessment = (
  id,
  machineryRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_MACHINERY_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_rec_of_sup_assessments/${machineryRecordofSupAssessmentId}`,
    callback,
    payload
  );

export const createMachineryRecordofSupAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_rec_of_sup_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMachineryRecordofSupAssessment = (
  id,
  machineryRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_rec_of_sup_assessments/${machineryRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeMachineryRecordofSupAssessment = (
  id,
  machineryRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_MACHINERY_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_rec_of_sup_assessments/${machineryRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getMachineryTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_TRANSACTION,
    `api/v1/rpt/administrator/machineries/machinery_applications/${id}/machinery_transactions`,
    payload,
    callback
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    callback,
    payload
  );

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    callback
  );

export const getLandOwnerList = (payload, callback) =>
  req.list(
    c.GET_LAND_OWNER,
    'api/v1/rpt/administrator/land/land_owners',
    payload,
    callback
  );

export const getSingleLandOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    callback,
    payload
  );

export const getBuildingOwnerList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_OWNER,
    'api/v1/rpt/administrator/buildings/building_owners',
    payload,
    callback
  );

export const getSingleBuildingOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_OWNER,
    `api/v1/rpt/administrator/buildings/building_owners/${id}`,
    callback,
    payload
  );

export const getMachineryOwnerList = (payload, callback) =>
  req.list(
    c.GET_MACHINERY_OWNER,
    'api/v1/rpt/administrator/machineries/machinery_owners?isPaginate=1',
    payload,
    callback
  );

export const getSingleMachineryOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_MACHINERY_OWNER,
    `api/v1/rpt/administrator/machineries/machinery_owners/${id}`,
    callback,
    payload
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICTS_LIST,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    callback
  );

export const getPostedLandApplication = (tdn, payload, callback) =>
  req.item(
    c.GET_POSTED_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${tdn}/posted`,
    callback,
    payload
  );

export const getPostedBuildingApplication = (tdn, params, callback) => {
  return req.item(
    c.GET_POSTED_BUILDING_APPLICATION,
    `/api/v1/rpt/administrator/buildings/building_applications/${tdn}/posted`,
    callback,
    params
  );
};

export const getAppointedPersons = (payload, callback) =>
  req.list(
    c.GET_APPOINTED_PERSONS,
    'api/v1/rpt/administrator/land/settings/land_person_of_concern',
    payload,
    callback
  );

export const createMachineryApplicationTransaction = (payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_TRANSACTION,
    `/api/v1/rpt/administrator/machineries/applications`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getKindOfMachinery = (payload, callback) =>
  req.list(
    c.GET_LIST_OF_MACHINERY,
    'api/v1/rpt/administrator/machineries/settings/machines',
    payload,
    callback
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

export const postMachineryApplication = (id, callback) =>
  req.create(
    c.POST_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/applications/${id}/post`,
    {},
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const unpostMachineryApplication = (id, payload, callback) =>
  req.create(
    c.UNPOST_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/applications/${id}/unpost`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const inquireMachineryApplication = (payload, callback) =>
  req.item(
    c.INQUIRE_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/applications/tdn/validate`,
    (res) => {
      const { data } = res;
      if (callback) callback({ data });
    },
    payload
  );

export const revertMachineryApplication = (id, callback) =>
  req.create(
    c.REVERT_MACHINERY_APPLICATION,
    `/api/v1/rpt/administrator/machineries/applications/${id}/revert`,
    {},
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getMachineryApplicationEffectivityPeriod = (
  id,
  payload,
  callback
) =>
  req.list(
    c.GET_MACHINERY_APPLICATION_EFFECTIVITY_PERIOD,
    `/api/v1/rpt/administrator/machineries/applications/${id}/effectivity_periods`,
    payload,
    callback
  );

export const getMachineryTaxEffectivityPeriod = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_TAX_EFFECTIVITY_PERIOD,
    `/api/v1/rpt/administrator/machineries/applications/${id}/tax_effectivity_periods`,
    payload,
    callback
  );

export const getMachineryApplicationLogs = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_APPLICATION_LOGS,
    `/api/v1/rpt/administrator/machineries/applications/${id}/logs`,
    payload,
    callback
  );
